// extracted by mini-css-extract-plugin
module.exports = {"form":"UploadDisabilityInput_form__3RI08","root":"UploadDisabilityInput_root__1MIbG","fileImg":"UploadDisabilityInput_fileImg__3rr-I"};